import { Component, OnInit } from "@angular/core";
import { BuyersOrderReportService } from "src/app/services/sales-reports/buyers-order-report.service";
import { faPrint, faEye } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-buyers-order-report",
  templateUrl: "./buyers-order-report.component.html",
  styleUrls: ["./buyers-order-report.component.css"],
})
export class BuyersOrderReportComponent implements OnInit {
  // ─── Icons ───────────────────────────────────────────────
  faEye = faEye;
  faPrint = faPrint;

  // ─── State ───────────────────────────────────────────────
  showTable = false;
  lockButtons = false;
  tableEntries: any[] = [];
  environment = environment;

  // ─── Form ────────────────────────────────────────────────
  formFields: FormField[] = [
    {
      type: "date",
      id: "FromDate",
      label: "From Buyer's Order Date (dd/mm/yyyy) *",
      value: "",
      required: true,
    },
    {
      type: "date",
      id: "ToDate",
      label: "To Buyer's Order Date (dd/mm/yyyy) *",
      value: "",
      required: true,
    },
    {
      type: "select",
      id: "Show",
      label: "Show",
      value: "All",
      options: [
        { display: "My buyers order", value: "BuyerOrder" },
        {
          display: "My team's buyers order",
          value: "TeamBuyerOrder",
        },
        { display: "All buyers order", value: "All" },
      ],
    },
    {
      type: "select",
      id: "GroupBy",
      label: "Group By",
      value: "",
      options: [
        { display: "", value: "" },
        { display: "Model Group", value: "ModelGroup" },
        { display: "Customer NRIC", value: "CustomerNRIC" },
        { display: "Customer Name", value: "CustomerName" },
        { display: "Sales Consultant", value: "Salesconsultant" },
        { display: "Sales Team", value: "Salesteam" },
        { display: "Registration Date", value: "RegistrationDate" },
      ],
    },
    {
      type: "select",
      id: "SortBy",
      label: "Sort By",
      value: "",
      options: [
        { display: "", value: "" },
        { display: "Model Group", value: "ModelGroup" },
        { display: "Sales Consultant", value: "Salesconsultant" },
        { display: "Sales Team", value: "Salesteam" },
        { display: "Customer Name", value: "CustomerName" },
        { display: "Contract No", value: "ContractNo" },
        { display: "Contract Date", value: "ContractDate" },
        { display: "Buyer Order No", value: "BuyerOrderNo" },
        { display: "Buyer Order Date", value: "BuyerOrderDate" },
        { display: "Registration Date", value: "RegistrationDate" },
        { display: "Registration No", value: "RegistrationNo" },
      ],
    },
    {
      type: "select",
      id: "Format",
      label: "Select format",
      value: "pdf",
      options: [
        { display: "PDF", value: "pdf" },
        { display: "EXCEL", value: "excel" },
        { display: "BOTH", value: "both" },
      ],
    },
  ];

  // ─── Table ───────────────────────────────────────────────
  tableHeaders = [
    { title: "BUYER'S ORDER NUMBER", type: "link", id: "RefNo" },
    { title: "BUYER ORDER DATE", type: "data", id: "RefDate" },
    { title: "CONTRACT NO.", type: "data", id: "ContactNo" },
    {
      title: "CONTRACT DATE (AUTOPAC)",
      type: "data",
      id: "ContractDate",
    },
    { title: "CUSTOMER NAME", type: "data", id: "CustomerName" },
    { title: "SMAN CODE", type: "data", id: "SALESCONSULTANT" },
    { title: "VEHICLE MODEL", type: "link", id: "Model" },
    { title: "MODEL COLOUR", type: "data", id: "Color" },
    { title: "COE TYPE", type: "data", id: "COEType" },
    {
      title: "COE OFFSET (REBATE LEVEL)",
      type: "data",
      id: "COERebateLevel",
    },
    { title: "LOAN AMOUNT", type: "data", id: "LoanAmount" },
    { title: "LOAN RATE", type: "data", id: "LoanRate" },
    { title: "LOAN PERIOD", type: "data", id: "LoanPeriod" },
    { title: "LOAN REMARK", type: "data", id: "LoanRemark" },
    { title: "FINANCE STATUS", type: "data", id: "FinStatus" },
    { title: "CASE NO.", type: "data", id: "VINNumber" },
    {
      title: "PRICE (INCLUSIVE OF FREE OPTIONS & GST)",
      type: "data",
      id: "FinalSellingPrice",
    },
    { title: "DEPOSIT (REPORT)", type: "data", id: "Deposit" },
    { title: "REGISTER DATE", type: "data", id: "RegisterDate" },
    { title: "", type: "hidden", id: "MODELCODE" },
  ];

  constructor(
    private buyersOrderReportService: BuyersOrderReportService,
  ) {}

  // ─── Lifecycle ───────────────────────────────────────────

  ngOnInit(): void {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setMonth(fromDate.getMonth() - 1);

    this.getField("ToDate").value = this.formatLocal(today);
    this.getField("FromDate").value = this.formatLocal(fromDate);
  }

  // ─── Form Events ─────────────────────────────────────────

  updateFields(): void {
    this.lockButtons = !(
      this.getField("FromDate").value && this.getField("ToDate").value
    );
  }

  // ─── Actions ─────────────────────────────────────────────

  preview(): void {
    this.buyersOrderReportService
      .previewBuyerOrder(this.buildPayload())
      .subscribe({
        next: (response) => {
          this.tableEntries = (response.body || []).map(
            (group: any) => ({
              ModelGroup: group.ModelGroup || "",
              TotalRecords: group.CrmBookingReport.length,
              Entries: group.CrmBookingReport.map((entry: any) => {
                const keys = [
                  "RefNo",
                  "RefDate",
                  "ContactNo",
                  "ContractDate",
                  "CustomerName",
                  "SALESCONSULTANT",
                  "Model",
                  "Color",
                  "COEType",
                  "COERebateLevel",
                  "LoanAmount",
                  "LoanRate",
                  "loanPeriod",
                  "LoanRemark",
                  "FinStatus",
                  "VINNumber",
                  "FinalSellingPrice",
                  "Deposit",
                  "RegisterDate",
                  "MODELCODE",
                ];
                return Object.fromEntries(
                  keys.map((k) => [k, entry[k]]),
                );
              }),
            }),
          );
          this.showTable = true;
        },
        error: (error) =>
          console.error("Error fetching data:", error),
      });
  }

  export(): void {
    const format = this.getField("Format").value;

    this.buyersOrderReportService
      .bookingReport(this.buildPayload())
      .subscribe({
        next: (response) => {
          if (format === "pdf" || format === "both")
            window.open(response.body.Name, "_blank");
          if (format === "excel" || format === "both")
            window.open(response.body.Value, "_blank");
        },
        error: (error) => console.error(error),
      });
  }

  openEntry(type: string, entry: any): void {
    const base = environment.KAPS_V1_DIRECT_URL + "Home.aspx#/";
    switch (type) {
      case "RefNo":
        window.location.href = `${base}bookingrequest?searchtext=${entry["RefNo"]}&searchoption=BuyerOrder`;
        break;
      case "Model":
        window.location.href = `${base}vehicleselection?model=${entry["MODELCODE"]}&colour=${entry["Color"]}`;
        break;
    }
  }

  // ─── Helpers ─────────────────────────────────────────────

  private buildPayload(): any {
    return {
      model: {
        FromDate: this.formatDate(this.getField("FromDate").value),
        ToDate: this.formatDate(this.getField("ToDate").value),
        ResultBy: this.getField("Show").value,
        SortBy: this.getField("SortBy").value || "",
        GroupBy: this.getField("GroupBy").value || "",
      },
    };
  }

  private getField(id: string): FormField {
    return (
      this.formFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: null,
      }
    );
  }

  private formatLocal(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, "0");
    const d = date.getDate().toString().padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  private formatDate(dateString: string): string {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  }
}
